import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ExternalEoiFormComponent } from '../../public-page/external-eoi-form/external-eoi-form.component';
import { ExternalEoiLinksComponent } from './external-eoi-links.component';

@NgModule({
  declarations: [ExternalEoiLinksComponent],
  imports: [CommonModule, ExternalEoiFormComponent],
  exports: [ExternalEoiLinksComponent],
})
export class ExternalEoiLinksModule {}
